<script>
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    export let selectorOptions;
    export let selected;
    export let selectorName;
    export let styleOverride = "width: auto";

    function selectionChanged(event) {
        var index = event.target.options.selectedIndex;
        dispatch("selector-changed", {
            name: selectorName,
            value: selectorOptions[index].value,
        });
    }
</script>

<select
    style={styleOverride}
    bind:value={selected}
    name={selectorName}
    class="dropdown-options"
    on:input={selectionChanged}
>
    {#each selectorOptions as opt}
        {#if opt.value == selected}
            <option value={opt.value} selected>
                {opt.title}
            </option>
        {:else}
            <option value={opt.value}>
                {opt.title}
            </option>
        {/if}
        <!-- <option value={opt.value}> -->
            <!-- {opt.title}
        </option> -->
    {/each}
</select>

<style>
    .dropdown-options {
        margin: auto;
    }
</style>
